import TabsLink from './tabsLink'

const tabsLink = new TabsLink()
tabsLink.init()
